module.exports = __webpack_public_path__ + "img/baleseng_mkandabili.322d8bde.png";